import React, { ReactNode } from 'react';

const CardWithHeader = ({
  title,
  children,
  rightSection
}: {
  title: string;
  children: ReactNode;
  rightSection?: JSX.Element;
}) => {
  return (
    <div className='bg-[#F7F7F8] w-full h-[100%] p-1 rounded-md '>
      <div className='bg-white w-full rounded-t-md pt-4 py-3 flex items-center justify-between mb-1 px-6'>
        <label className='text-base md:text-lg font-medium'>{title}</label>
        {rightSection && rightSection}
      </div>

      <div className='bg-white w-full rounded-b-md py-4 px-6'>{children}</div>
    </div>
  );
};

export default CardWithHeader;
